/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    /* responsive switch */

    function Viewport() {
        this.viewport = function (a) {
            var b = document, d = b.documentElement;
            b.head = b.head || b.getElementsByTagName("head")[0];
            var e = screen, c = this, f = window;
            c.bScaled = !1;
            c.bSupported = !0;
            b.addEventListener === a ? c.bSupported = !1 : b.querySelector === a ? c.bSupported = !1 : f !== parent ? c.bSupported = !1 : f.orientation === a && (c.bSupported = !1);
            c.updateOrientation();
            c.updateScreen();
            c.dpr = 1;
            var g = f.devicePixelRatio;
            g === a ? c.bSupported = !1 : c.dpr = g;
            c.fromHead();
            this.meta !== a && (c.iHeight = c.height, c.iMaxScale = c.maxScale, c.iMinScale =
                c.minScale, c.iUserScalable = c.bUserScalable, c.iWidth = c.width);
            c.defaultWidth = 1170;
            e.width > c.defaultWidth && (c.defaultWidth = e.width);
            e.height > c.defaultWidth && (c.defaultWidth = e.height);
            c.ready(function () {
                if (c.bSupported) {
                    if (f.screenX !== 0)c.bSupported = false; else if (c.width !== a) {
                        var e;
                        if (d.offsetHeight <= d.clientHeight) {
                            e = d.style.height;
                            d.style.height = d.clientHeight + 128 + "px"
                        }
                        if (c.width === "device-width") {
                            if (d.clientWidth !== c.screenWidth)c.bSupported = false
                        } else if (c.width !== d.clientWidth)c.bSupported = false;
                        e === "" ? d.style.height = "auto" : e !== a && (d.style.height = e)
                    }
                    if (c.bSupported) {
                        b.addEventListener("touchend", function () {
                            var b = (new Date).getTime();
                            if (c.lastTouch !== a && b - c.lastTouch < 500 && c.bUserScalable === true)c.bScaled = true;
                            c.lastTouch = b
                        }, false);
                        b.addEventListener("gestureend", function (a) {
                            if (a.scale !== 1 && c.bUserScalable === true)c.bScaled = true
                        }, false);
                        b.addEventListener("resize", function () {
                            c.updateCheck()
                        }, false);
                        b.addEventListener("orientationchange", function () {
                            var b = c.orientation;
                            c.updateOrientation();
                            if (b !==
                                c.orientation) {
                                c.updateScreen();
                                if (c.bUserScalable === true)c.bScaled = true;
                                c.orientationChangePolicy !== a && c.orientationChangePolicy()
                            }
                        }, false)
                    }
                }
                c.readyPolicy !== a && c.readyPolicy()
            })
        };
        this.fromContentString = function (a) {
            for (var a = a.split(","), b, d, e = 0; e < a.length; e++)b = a[e].split("="), 2 === b.length && (d = b[0].trim(), b = b[1].trim(), isNaN(parseFloat(b)) || (b = parseFloat(b)), "width" === d ? this.width = b : "height" === d ? this.height = b : "initial-scale" === d ? this.initialScale = b : "maximum-scale" === d ? this.maxScale = b : "minimum-scale" ===
            d ? this.minScale = b : "user-scalable" === d && (this.bUserScalable = "no" === b ? !1 : !0))
        };
        this.fromHead = function () {
            var a = this.meta = document.head.querySelector("meta[name=viewport]");
            null === a ? this.meta = void 0 : a.hasAttribute("content") && this.fromContentString(a.getAttribute("content"))
        };
        this.ready = function (a) {
            var b = document;
            b.addEventListener && b.addEventListener("DOMContentLoaded", function () {
                b.removeEventListener("DOMContentLoaded", arguments.callee, !1);
                a()
            }, !1)
        };
        this.setDefault = function (a, b) {
            this.bUserScalable = !0;
            this.height = void 0;
            this.maxScale = 5;
            this.minScale = 0.25;
            this.width = this.defaultWidth;
            this.update(a, b)
        };
        this.setMobile = function (a, b) {
            this.bScaled ? b() : (void 0 === this.iWidth ? (this.bUserScalable = !1, this.height = void 0, this.minScale = this.maxScale = 1, this.width = "device-width") : (this.bUserScalable = this.iUserScalable, this.height = this.iHeight, this.maxScale = this.iMaxScale, this.minScale = this.iMinScale, this.width = this.iWidth), this.update(a, b))
        };
        this.toString = function () {
            var a = "";
            void 0 !== this.width && (a += "width=" +
            this.width + ", ");
            void 0 !== this.height && (a += "height=" + this.height + ", ");
            void 0 !== this.maxScale && (a += "maximum-scale=" + this.maxScale + ", ");
            void 0 !== this.minScale && (a += "minimum-scale=" + this.minScale + ", ");
            !0 === this.bUserScalable ? a += "user-scalable=yes" : !1 === this.bUserScalable && (a += "user-scalable=no");
            return a
        };
        this.update = function (a, b) {
            var d = this;
            if (d.bSupported) {
                d.updateFailure = b;
                d.updateSuccess = a;
                var e = d.width;
                "device-width" === e && (e = d.screenWidth);
                e = d.prevWidth;
                "device-width" === e ? e = d.screenWidth : void 0 ===
                e && (e = document.documentElement.clientWidth);
                d.updateMeta();
                d.updateTimeout = setTimeout(function () {
                    d.updateCheck()
                }, 500)
            } else b()
        };
        this.updateCheck = function () {
            if (void 0 !== this.updateTimeout) {
                var a = !1, b = document.documentElement.clientWidth;
                this.width === b ? a = !0 : "device-width" === this.width && this.screenWidth === b && (a = !0);
                clearTimeout(this.updateTimeout);
                this.updateTimeout = void 0;
                a ? (this.prevWidth = this.width, this.updateSuccess(), this.viewportChange()) : (this.bSupported = !1, this.updateFailure());
                this.updateSuccess =
                    this.updateFailure = void 0
            }
        };
        this.updateMeta = function () {
            var a = document, b = this.meta;
            void 0 === b ? (b = this.meta = a.createElement("meta"), b.setAttribute("name", "viewport"), b.setAttribute("content", this.toString()), a.head.appendChild(b)) : b.setAttribute("content", this.toString())
        };
        this.updateOrientation = function () {
            var a = window.orientation;
            this.orientation = a = 0 === a || 180 === a ? "portrait" : 90 === a || -90 === a ? "landscape" : document.documentElement.clientWidth > document.documentElement.clientHeight ? "landscape" : "portrait"
        };
        this.updateScale = function () {
            this.scale = this.screenWidth / window.innerWidth
        };
        this.updateScreen = function () {
            var a = this.screenHeight = screen.height, b = this.screenWidth = screen.width;
            "portrait" === this.orientation ? b > a && (this.screenHeight = b, this.screenWidth = a) : b < a && (this.screenHeight = b, this.screenWidth = a)
        };
        this.viewportChange = function () {
            var a = document.createEvent("Event");
            a.initEvent("viewportChange", !0, !0);
            a.bUserScalable = this.bUserScalable;
            a.maxScale = this.maxScale;
            a.minScale = this.minScale;
            a.width = this.width;
            document.dispatchEvent(a)
        };
        return !0
    }

    var reView;
    (function (a) {
        reView = new ReView;
        if (reView.v.bSupported)try {
            if ("sessionStorage"in a && null !== a.sessionStorage) {
                var b = sessionStorage.getItem("reViewMode");
                "core" === reView.mode && "default" === b ? reView.setDefault() : "default" === reView.mode && "core" === b && reView.setCore()
            } else reView.v.bSupported = !1
        } catch (d) {
            reView.v.bSupported = !1
        }
    })(window);
    function ReView() {
        this.mode = "default";
        this.v = new Viewport;
        this.v.viewport();
        this.v.readyPolicy = function () {
            reView.ready()
        };
        this.v.bSupported && "device-width" === this.v.width && (this.mode = "core");
        this.failure = function () {
            var a = reView;
            a.mode === "default" && a.v.iWidth !== void 0 && window.location.reload();
            a.failurePolicy !== void 0 && a.failurePolicy()
        };
        this.ready = function () {
            var a = document.getElementsByClassName("reView"), b = a.length, d = reView;
            if (d.v.bSupported) {
                for (d.mode === "default" && sessionStorage.getItem("reViewMode") !==
                "core" && d.success(); b--;)a[b].style.display = "inline";
                document.body.addEventListener("click", function (a) {
                    if (a.target.hasAttribute("class") && a.target.getAttribute("class").indexOf("reView") > -1) {
                        a.preventDefault();
                        d.mode === "default" ? d.setCore() : d.mode === "core" && d.setDefault()
                    }
                })
            } else for (screen.width >= 1024 && d.success(); b--;)a[b].style.display = "none"
        };
        this.setCore = function () {
            if (this.mode === "core")this.success(); else if (this.v.bSupported) {
                try {
                    sessionStorage.setItem("reViewMode", "core")
                } catch (a) {
                }
                this.v.setMobile(function () {
                    reView.mode =
                        "core";
                    reView.success()
                }, reView.failure)
            } else this.failure()
        };
        this.setDefault = function () {
            if (this.mode === "default")this.success(); else if (this.v.bSupported) {
                try {
                    sessionStorage.setItem("reViewMode", "default")
                } catch (a) {
                }
                this.v.setDefault(function () {
                    reView.mode = "default";
                    reView.success()
                }, reView.failure)
            } else this.failure()
        };
        this.success = function () {
            var a = reView;
            a.v.bSupported && a.updateAnchors();
            a.successPolicy !== void 0 && a.successPolicy()
        };
        this.updateAnchors = function () {
            var a = document.getElementsByClassName("reView"),
                b = a.length;
            if (this.mode === "core")for (; b--;)a[b].innerHTML = a[b].hasAttribute("data-coreText") ? a[b].getAttribute("data-coreText") : "Default View"; else for (; b--;)a[b].innerHTML = a[b].hasAttribute("data-defaultText") ? a[b].getAttribute("data-defaultText") : "Core View"
        };
        return !0
    };

    /* responsive switch */


    function setSameHeight() {
        if (jQuery(".sameHeight").length) {
            jQuery(".sameHeight .row").each(function () {
                contentPartMax = 0;
                jQuery(this).find("div.item").each(function () {
                    contentPart = jQuery(this).height();
                    if (contentPart > contentPartMax) {
                        contentPartMax = contentPart;
                    }
                });
                jQuery(this).find("div.item").height(contentPartMax);
            });
        }
    };


    function verticalCenter() {

        jQuery(".vertical-center").each(function () {
            var centeredObject = jQuery(this);
            var parentHeight = jQuery(centeredObject).find("parent").height();

            if (jQuery(centeredObject).hasClass("bootstrap")) {
                var maxHeight = 0;
                jQuery(centeredObject).parent().parent().find("div").each(function () {
                    if (maxHeight < jQuery(this).height()) {
                        maxHeight = jQuery(this).height();
                    }
                });
                jQuery(centeredObject).parent().height(maxHeight).addClass("vcentered");
            }

            var movement = ((jQuery(centeredObject).parent().height() - jQuery(centeredObject).height()) / 2);
            jQuery(centeredObject).css("top", movement + "px").addClass("vcentered");
        });
    }

    function galleryButton() {
        jQuery("a.button#galleryMore").on("click", function (event) {
            event.preventDefault();
            var hideText = jQuery(this).data( "hide" );
            var showText = jQuery(this).data( "show" );

            if (jQuery(this).hasClass("displayed")){
                jQuery(this).html(showText).removeClass("displayed");
                jQuery("#gallery .galleryRow:not(:first)").hide();
            }else{
                jQuery(this).html(hideText).addClass("displayed").parent().parent().parent().parent().find(".galleryRow:hidden").fadeIn();
            }
        });
    }

    function validateEmail($email) {
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        return emailReg.test($email);
    }


    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                jQuery(".videoFancy").fancybox(
                    {
                        'type' : 'iframe',
                        'width' : 640,
                        'height' : 360,
                        'padding' : 0,
                        'scrolling': 'no',
                        'iframe': {'scrolling': 'no'}
                    });

                jQuery("section#slider .buttons a[href='']").on("click", function (event) {
                    event.preventDefault();
                    jQuery('html, body').animate({
                        scrollTop: jQuery("section:nth-of-type(2)").offset().top - 20
                    }, 700);
                });

                jQuery("header nav ul li.menu-item-27 a").on("click", function (event) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: jQuery("section#contact").offset().top - 20
                    }, 700);
                });


                jQuery("header").autoHidingNavbar({
                    hideOffset: 400
                });

                jQuery("span.mobile-hamburger").on("click", function () {
                    jQuery(this).toggleClass("active");
                    jQuery("header nav").slideToggle();
                });

                jQuery(".fancybox").fancybox({
                    tpl: {
                        next: '<a title="Další" class="fancybox-nav fancybox-next"><span></span></a>',
                        prev: '<a title="Předchozí" class="fancybox-nav fancybox-prev"><span></span></a>'
                    }
                });

                jQuery(".fancyboxgallery").fancybox({
                    tpl: {
                        next: '<a title="Další" class="fancybox-nav fancybox-next"><span></span></a>',
                        prev: '<a title="Předchozí" class="fancybox-nav fancybox-prev"><span></span></a>'
                    },
                    helpers : {
                        title: {
                            type: 'inside'
                        }
                    },
                    padding:5
                });

                jQuery(window).on("resize", function () {
                    verticalCenter();
                });

                jQuery(".accordion .acc_front").on("click", function () {
                    var thisAccordion = jQuery(this);
                    if (jQuery(thisAccordion).hasClass("active")) {
                        jQuery(thisAccordion).removeClass("active");
                        jQuery(thisAccordion).parent().find(".acc_back:visible").slideUp();
                    }
                    else {
                        if (jQuery(this).parent().parent().find(".acc_back:visible").length) {
                            jQuery(this).parent().parent().find(".acc_back:visible").slideUp(function () {
                                jQuery(this).parent().find(".acc_front").removeClass("active");
                                jQuery(thisAccordion).addClass("active").parent().find(".acc_back").slideDown();
                            });
                        } else {
                            jQuery(thisAccordion).addClass("active").parent().find(".acc_back").slideDown();
                        }
                    }
                });


                jQuery(window).load(function () {
                    verticalCenter();
                });

                jQuery("#newsletter input[type=submit], #newsletter_homepage input[type=submit], #newsletter_catalogue input[type=submit]").on("click", function (event) {
                    event.preventDefault();

                    var form = jQuery(this).parent();
                    var error = 0;
                    var newsletterEmail = form.find("input[name=email]").val();

                    if (newsletterEmail == "") {
                        error = 1;
                        form.find("span.error").html("Musíte vyplnit e-mail").fadeIn();
                    } else if (!validateEmail(newsletterEmail)) {
                        form.find("span.error").html("E-mail nemá správný formát!").fadeIn();
                        error = 1;
                    }


                    if (error == 0) {
                        var mail = newsletterEmail;
                        var honey = form.find("input[name=honey]").val();
                        jQuery.ajax({
                            type: 'post',
                            url: ajaxurl,
                            data: {action: "newsletter_footer", mail: mail, honey: honey},
                            success: function (response) {
                                form.fadeOut(function () {
                                    form.parent().append("<span class=\"newsletterOK\">Váš e-mail byl přidán do databáze!</span>");
                                });
                            }
                        });
                    }
                });



                jQuery("#newsletter_download input[type=submit]").on("click", function (event) {
                    event.preventDefault();

                    var form = $(this).parent();
                    var error = 0;
                    var newsletterEmail = jQuery(form).find("input[name=newsletter_mail]").val();

                    if (newsletterEmail == "") {
                        error = 1;
                        jQuery(form).parent().find("span.error").html("Musíte vyplnit e-mail").fadeIn();
                    } else if (!validateEmail(newsletterEmail)) {
                        jQuery(form).parent().find("span.error").html("E-mail nemá správný formát!").fadeIn();
                        error = 1;
                    }

                    if (error == 0) {
                        var mail = jQuery(form).find("input[name=newsletter_mail]").val();
                        var honey = jQuery(form).find("input[name=honey]").val();
                        $.ajax({
                            type: 'post',
                            url: ajaxurl,
                            data: {action: "newsletter_footer", mail: mail, honey: honey},
                            success: function (response) {
                                jQuery(form).fadeOut(function () {
                                    jQuery(form).parent().find("span.error").hide();
                                    jQuery(form).parent().append("<span class=\"newsletterOK\">Váš e-mail byl přidán do databáze!</span>");
                                });

                            }
                        });
                    }
                });


                jQuery("#contact form input[type=submit]").on("click", function (event) {
                    event.preventDefault();


                    var form = jQuery(this).parent().parent();
                    var submitInput = jQuery(this);


                    if (!jQuery(form).hasClass("clicked")) {

                        jQuery(form).addClass("clicked");


                        var error = 0;
                        var newsletterPhone = jQuery(form).find("input[name=phone]").val();
                        var newsletterName = jQuery(form).find("input[name=name]").val();
                        var newsletterLastName = jQuery(form).find("input[name=lastName]").val();
                        var newsletterValue = jQuery(form).find("input[name=value]").val();

                        if ((newsletterPhone == "") || (newsletterLastName == "") || (newsletterName == "")) {
                            error = 1;
                            jQuery(form).find("span.err").html("Musíte vyplnit všechna formulářová pole!").fadeIn();
                            jQuery(form).removeClass("clicked");
                        }

                        if (error == 0) {
                            jQuery(submitInput).addClass("sent").val("Odesílám formulář!");
                            var honey = jQuery("#contact form input[name=honey]").val();
                            $.ajax({
                                type: 'post',
                                url: ajaxurl,
                                data: {
                                    action: "newsletter",
                                    name: newsletterName,
                                    phone: newsletterPhone,
                                    lastName: newsletterLastName,
                                    honey: honey,
                                    value: newsletterValue
                                },
                                success: function (response) {
                                    jQuery("#contact form").fadeOut(function () {
                                        jQuery("#contact form").parent().append("<span class=\"newsletterOK\">Děkujeme za vaší důvěru. Do 3 pracovních dnů vás budeme kontaktovat.</span>");
                                    });
                                    if (newsletterValue > 0) {
                                        ga('send', 'event', 'Kontaktní formulář', 'Odeslání', 'Odesláno', newsletterValue);
                                        var housevalue = newsletterValue;
                                    } else {
                                        ga('send', 'event', 'Kontaktní formulář', 'Odeslání', 'Odesláno', 3400000);
                                        var housevalue = 3400000;
                                    }
                                    var iframe = document.createElement('iframe');
                                    iframe.style.width = '0px';
                                    iframe.style.height = '0px';
                                    document.body.appendChild(iframe);
                                    iframe.src = 'http://www.domy-drevostavby-na-klic.cz/wp-content/themes/drevostavby/templates/facebook.php?val=' + housevalue;
                                }
                            });
                        }

                    }

                });


            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page


            },
            finalize: function () {
                
                

                    //var wow = new WOW(
                    //    {
                    //        boxClass:     'wow',      // animated element css class (default is wow)
                    //        animateClass: 'animated', // animation css class (default is animated)
                    //        offset:       0,          // distance to the element when triggering the animation (default is 0)
                    //        mobile:       false,       // trigger animations on mobile devices (default is true)
                    //        live:         true,       // act on asynchronously loaded content (default is true)
                    //        callback:     function(box) {
                    //            // the callback is fired every time an animation is started
                    //            // the argument that is passed in is the DOM node being animated
                    //        }
                    //    }
                    //);
                    //wow.init();


                    var mySliderSettings = {
                        minSlides: 1,
                        maxSlides: 1,
                        moveSlides: 1,
                        slideSelector: '.slide',
                        responsive: true,
                        mode: 'fade',
                        auto: true,
                        pause: 6000
                    };

                    var gallerySlider = $('section#slider').bxSlider(mySliderSettings);

                
      
            }
        },
        'certifikace': {
            init: function () {


                var switched = false;
                var updateTables = function () {
                    if (($(window).width() < 767) && !switched) {
                        switched = true;
                        $("table.responsive").each(function (i, element) {
                            splitTable($(element));
                        });
                        return true;
                    }
                    else if (switched && ($(window).width() > 767)) {
                        switched = false;
                        $("table.responsive").each(function (i, element) {
                            unsplitTable($(element));
                        });
                    }
                };
                $(window).load(updateTables);
                $(window).bind("resize", updateTables);
                function splitTable(original) {
                    original.wrap("<div class='table-wrapper' />");
                    var copy = original.clone();
                    copy.find("td:not(:first-child), th:not(:first-child)").css("display", "none");
                    copy.removeClass("responsive");
                    original.closest(".table-wrapper").append(copy);
                    copy.wrap("<div class='pinned' />");
                    original.wrap("<div class='scrollable' />");
                }

                function unsplitTable(original) {
                    original.closest(".table-wrapper").find(".pinned").remove();
                    original.unwrap();
                    original.unwrap();
                }


            }
        },
        'page_template_page_technology': {
            init: function () {

                jQuery(document).ready(function () {
                    jQuery(".marker i").hover(function () {
                        jQuery(this).parent().addClass("active").find(".inner").stop(true, true).animate({opacity: 1});
                    });
                });

                jQuery(".marker").mouseleave(function () {
                    jQuery(this).find(".inner").stop(true, true).animate({opacity: 0}).parent().removeClass("active");
                });


            }
        },
        'post_type_archive': {
            init: function () {

                jQuery(document).ready(function () {
                    jQuery("#filters select").selectric({
                        onChange: function () {
                            var catIndex = jQuery(".selectric-items").find("li.selected").attr("data-index");
                            window.location.replace(jQuery("#categoriesSelect option:eq(" + catIndex + ")").prop("value"));
                        }
                    });
                });
            }
        },
        'archive': {
            init: function () {

                jQuery(document).ready(function () {
                    jQuery("#filters select").selectric({
                        onChange: function () {
                            var catIndex = jQuery(".selectric-items").find("li.selected").attr("data-index");
                            window.location.replace(jQuery("#categoriesSelect option:eq(" + catIndex + ")").prop("value"));
                        }
                    });
                });
            }
        },
        'single_post': {
            init: function () {

                galleryButton();


            }
        },
        'single_inspiration': {
            init: function () {

                galleryButton();

                jQuery("#postNewsletter input[type=submit]").on("click", function (event) {
                    event.preventDefault();

                    var form = $(this).parent();
                    var error = 0;
                    var newsletterEmail = jQuery(form).find("input[name=email]").val();

                    if (newsletterEmail == "") {
                        error = 1;
                        jQuery(form).find("span.error").html("Musíte vyplnit e-mail!").fadeIn();
                    } else if (!validateEmail(newsletterEmail)) {
                        jQuery(form).find("span.error").html("E-mail nemá správný formát!").fadeIn();
                        error = 1;
                    }

                    if (error == 0) {
                        var honey = jQuery(form).find("input[name=honey]").val();
                        $.ajax({
                            type: 'post',
                            url: ajaxurl,
                            data: {action: "newsletter_footer", mail: newsletterEmail, honey: honey},
                            success: function (response) {
                                jQuery(form).fadeOut(function () {
                                    jQuery(form).parent().append("<span class=\"newsletterOK\">E-mail byl vložen do databáze. Děkujeme</span>");
                                });

                            }
                        });
                    }
                });



            }
        },
        'single_houses': {
            init: function () {

                setSameHeight();

                galleryButton();

                jQuery("#toFriend").click(function (e) {
                    e.preventDefault();
                    link = jQuery(this).prop("href");
                    jQuery.fancybox.open({
                        href: link,
                        type: 'iframe',
                        padding: 0,
                        width: 500
                    });
                });


            },
            finalize: function () {

                jQuery(".slideNext a.slideArrow,.slidePrev a.slideArrow").hover(function () {
                    if (jQuery(this).hasClass("right")) {
                        jQuery(this).stop().animate({right: "-47"});
                        jQuery(this).parent().find(".inner").stop().animate({right: "0"});
                    } else {
                        jQuery(this).stop().animate({left: "-47"});
                        jQuery(this).parent().find(".inner").stop().animate({left: "0"});
                    }
                });

                jQuery(".slidePrev .inner").mouseleave(function () {
                    jQuery(this).stop().animate({left: "-223"});
                    jQuery(this).parent().find("a.slideArrow").stop().animate({left: "0"});
                });

                jQuery(".slideNext .inner").mouseleave(function () {
                    jQuery(this).stop().animate({right: "-223"});
                    jQuery(this).parent().find("a.slideArrow").stop().animate({right: "0"});
                });

                var mySliderSettings = {
                    minSlides: 1,
                    maxSlides: 1,
                    moveSlides: 1,
                    slideSelector: '.slide',
                    responsive: true,
                    mode: 'fade',
                    auto: true,
                    pause: 6000,
                    nextText: '',
                    prevText: ''
                };

                var gallerySlider = $('section#slider').bxSlider(mySliderSettings);


                
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
               
    $( "header nav ul li" ).hover(
        function() {
            if (jQuery(window).width() > 992) { 
                $(this).find("ul").fadeIn(100);
            }
        }, function() {
            if (jQuery(window).width() > 992) { 
                $(this).find("ul").fadeOut(100);
            }
        }
    );
    
    $('header nav ul li.menu-item-has-children > a').click(function() {
        if (jQuery(window).width() < 993) { 
            var sel = $(this).hasClass("sel");
            if (sel==true){
                $(this).removeClass("sel");
                $(this).next("ul").fadeOut(100);
            }else{
                $(this).addClass("sel");
                $(this).next("ul").fadeIn(100);
            }
            return false;
        }
    });
    
    $(document).ready(function () {
        if (document.cookie.indexOf("favorite") == -1) {
            var cookie = "";
        }else{
            var cookie = $.cookie('favorite');
            var ar = cookie.split(",");
            ar.forEach(function(id) {
                if (id){
                    $(".favorite[data-id="+id+"]").addClass("sel");
                }
            });
        }        
    }); 
    
    
    $('.favorite').click(function() {
        if (document.cookie.indexOf("favorite") == -1) {
            var cookie = "";
        }else{
            var cookie = $.cookie('favorite');
        }        
        var id = $(this).attr("data-id");
        var sel =  $(this).hasClass("sel");
        var cookieAdd = "";
        if (sel == true){
            $(this).removeClass("sel");
            var cookie = $.cookie('favorite');
            var cookie = cookie.replace(id+",", ""); 
        }else{
            $(this).addClass("sel");
            var cookieAdd = id+",";
        }
        
        $.cookie('favorite',cookie+cookieAdd);

        return false;
    });  
    
    $('.priceType').click(function() {
        var hide = $(this).attr("data-type");
        var val = $(this).attr("data-val");
        $('#calc #cena-domu-na-klic').val(val);
        $('.priceType').removeClass("sel");
        $(this).addClass("sel");
        if (hide == "hide"){
            $("#house #included .service-wrapper:not(.hruba-stavba)").fadeOut(200);
        }else{
            $("#house #included .service-wrapper").fadeIn(200);
        }
        total();
        return false;
    });
    
    $('.iconLinks a').click(function() {
        return false;
    });

    function addCommas(str) {
        var parts = (str + "").split("."),
            main = parts[0],
            len = main.length,
            output = "",
            first = main.charAt(0),
            i;

        if (first === '-') {
            main = main.slice(1);
            len = main.length;    
        } else {
              first = "";
        }
        i = len - 1;
        while(i >= 0) {
            output = main.charAt(i) + output;
            if ((len - i) % 3 === 0 && i > 0) {
                output = "." + output;
            }
            --i;
        }
        // put sign back
        output = first + output;
        // put decimal part back
        if (parts.length > 1) {
            output += "," + parts[1];
        }
        return output;
    }
    function total_green(){
        var uzitnaPlocha = $("#greensave #uzitna-plocha").val();
        var months = $("#greensave .result.uspora-leta").text();
        var months = parseInt(months) * 12;
        $.ajax({
            type: 'post',
            url: ajaxurl,
            data: {action: "house_greensave",uzitnaPlocha: uzitnaPlocha,months:months},
            success: function (response) {
                var result = JSON.parse(response);
                $("#greensave .mesicni-uspora-js").text(result.mesicni_uspora);
                $("#greensave .uspora-leta-js").text(result.uspora_leta);
                $("#greensave .celkova-uspora-js").text(result.celkova_uspora);
            }
        });
    };
    
    function total(){
        var i = 0;
        window.totalPrice = 0;
        $('#calc .input input').each(function() {
            i++;
            if (i<4){
                var value = $(this).val();
                var value = value.replace(",-",""); 
                var value = value.replace(/\./g,"");
                window.totalPrice = parseInt(totalPrice) + parseInt(value);
            }
        }); 
        $("#calc #celkova-vyse-investice").val(addCommas(totalPrice)+",-");
        var downPayment = $("#calc .result.vyse-hotovostniho-vkladu").text();
        var months = $("#calc .result.delka-splaceni").text();
        var months = parseInt(months) * 12;
        $.ajax({
            type: 'post',
            url: ajaxurl,
            data: {action: "house_calc",totalPrice: totalPrice, months:months,downPayment:downPayment},
            success: function (response) {
                var result = JSON.parse(response);
                $("#calc .vase-mesicni-splatka").text(result.splatka);
                $("#calc .result.urokova-mira").text(result.urokova_mira);
            }
        });
    };

    if (jQuery("#calc").length){
        total();
    }
    
    $('#calc .input i').click(function() {
        var type = $(this).hasClass('plus');
        var value = $(this).parent().find("input").val();
        var value = value.replace(",-",""); 
        var value = value.replace(/\./g,"");
        var value = parseInt(value);
        
        if (type==true){
            var value = value + 50000;
        }else{
            var value = value - 50000;
        }
        if (value<0){
            var value=0;
        }
        $(this).parent().find("input").val(addCommas(value)+",-");
        
        total();
        
    });
    $( document ).on( "change", "#calc .input input", function() {
           
        total();

    });

    
    /** ranges */
    var rangeVal = $( '.range.vyse-hotovostniho-vkladu' ).attr("data-value");
    $( '.range.vyse-hotovostniho-vkladu' ).slider({
      range: "min",
      min: 0,
      max: 100,
      step: 1,
      value: rangeVal,
      slide: function( event, ui ) {
        $( ".result.vyse-hotovostniho-vkladu" ).text( ui.value );
        $( ".range.vyse-hotovostniho-vkladu .ui-slider-handle" ).html( "<i>" + ui.value +"%</i>");
      },
      stop: function( event, ui ) {
        total();
      }
    });
    $( ".result.vyse-hotovostniho-vkladu" ).text( $( '.range.vyse-hotovostniho-vkladu' ).slider( "value" ) );
    $( ".range.vyse-hotovostniho-vkladu .ui-slider-handle" ).html( "<i>" + $( '.range.vyse-hotovostniho-vkladu' ).slider( "value" ) +"%</i>");
    
    var rangeVal = $( '.range.delka-splaceni' ).attr("data-value");
    $( '.range.delka-splaceni' ).slider({
      range: "min",
      min: 5,
      max: 40,
      step: 1,
      value: rangeVal,
      slide: function( event, ui ) {
        $( ".result.delka-splaceni" ).text( ui.value );
        $( ".range.delka-splaceni .ui-slider-handle" ).html( "<i>" + ui.value +" let</i>");
      },
      stop: function( event, ui ) {
        total();
      }
    });
    $( ".result.delka-splaceni" ).text( $( '.range.delka-splaceni' ).slider( 'value' ) );
    $( ".range.delka-splaceni .ui-slider-handle" ).html( "<i>" + $( '.range.delka-splaceni' ).slider( "value" ) +" let</i>");
    
    var rangeVal = $( '.range.uzitna-plocha-domu' ).attr("data-value");
    $( '.range.uzitna-plocha-domu' ).slider({
      range: "min",
      min: 1,
      max: 210,
      step: 1,
      value: rangeVal,
      slide: function( event, ui ) {
        $( "#uzitna-plocha" ).val( ui.value );
        $( ".range.uzitna-plocha-domu .ui-slider-handle" ).html( "<i>" + ui.value +"m<sup>2</sup></i>");
      },
      stop: function( event, ui ) {
        total_green();
      }
    });
    $( ".result.uzitna-plocha-domu" ).text( $( '.range.uzitna-plocha-domu' ).slider( 'value' ) );
    $( ".range.uzitna-plocha-domu .ui-slider-handle" ).html( "<i>" + $( '.range.uzitna-plocha-domu' ).slider( "value" ) +"m<sup>2</sup></i>");
    
    var rangeVal = $( '.range.pocet-let-uzivani-domu' ).attr("data-value");
    $( '.range.pocet-let-uzivani-domu' ).slider({
      range: "min",
      min: 5,
      max: 84,
      step: 1,
      value: rangeVal,
      slide: function( event, ui ) {
        $( ".result.uspora-leta" ).text( ui.value );
        $( ".range.pocet-let-uzivani-domu .ui-slider-handle" ).html( "<i>" + ui.value +" let</i>");
      },
      stop: function( event, ui ) {
        total_green();
      }
    });
    $( ".result.pocet-let-uzivani-domu" ).text( $( '.range.pocet-let-uzivani-domu' ).slider( 'value' ) );
    $( ".range.pocet-let-uzivani-domu .ui-slider-handle" ).html( "<i>" + $( '.range.pocet-let-uzivani-domu' ).slider( "value" ) +" let</i>");
    /** ranges */
    
    $('.scrolling').bind('click', function (event) {

        var $anchor = $(this);
        var anch = $anchor.attr('href');
        var n = anch.indexOf("#"); 
        var res = anch.substr(n, 999)+"K";
        $('html, body').stop().animate({
            scrollTop: $(res).offset().top
        }, 500, 'easeInOutQuart'); 
        event.preventDefault();
    });
    
    $('.videoGallery a').bind('click', function (event) {
        $('.videoGallery a').removeClass("active");
        $(this).addClass("active");
        $('.videoGallery a .hover.playing div').text("Video se právě přehrává");
        var video = $(this).attr("data-url");
        $("#wood iframe").attr("src",video);
        var text = $(this).attr("data-value");
        $("#wood .footer p").html(text);
        event.preventDefault();
    });
    
    
    
    $( document ).tooltip({
      items: "[data-tool=tooltip]",
      content: function() {
        var element = $( this );
        return element.attr( "data-title" );
      },position: {
        my: "center bottom-10",
        at: "center top"
      }
    });


  
  
})(jQuery); // Fully reference jQuery after this point.


